<template>
    <v-dialog-old ref="dialog" id="network" @hidden="resetComponentData()">
        <image-cropper
            ref="cropper"
            :img="M.network.img"
            type="clinics"
            @crop-upload-success="cropUploadSuccess"
            upload-url="/imageCropperNew/networks"
        />
        <dialog-network-subscription ref="networkSubscriptionDialog"
                                     @confirm="handleCreatedSubscription"
                                     @edit="handleChangedSubscription"/>
        <ValidationObserver ref="networkEditForm">
            <form >
                <fieldset style="overflow: visible;">
                    <legend>Сеть</legend>

                    <table class="grid">
                        <tr>
                            <td valign="top" width="150">
                                <drag-and-drop @fileDropped="openCropWithNewFile">
                                    <div class="imageCropper">
                                        <button type="button" v-show="M.network.img !== ''"
                                            class="resetBtn small redHover" tooltip="Удалить логотип"
                                            @click.prevent.stop="imageCropperDelete">
                                            <i class="fas fa-trash-can"></i>
                                        </button>
                                        <img src=""
                                            :src="M.network.img ? storagePublicUrl + '/images/clinics/150x150/' + M.network.img : ''"
                                            width="150" height="150" @click.prevent.stop="imageCropperOpen"
                                            style="cursor: pointer; background-image: url(/_assets/pic_clinic.svg);" />
                                        <i v-if="M.network.proprietary === 'private'"
                                           class="button small"
                                           @click.prevent.stop="openNetworkPage"
                                           width="150"
                                           v-tooltip="`${$parent.$parent.frontendUrl}/${M.network.city === '' ? '—' : M.network.city}/net/${M.network.url}`"
                                           :disabled="!M.network.id"
                                           style="margin: 5px 0 !important;">
                                            <i class="fas fa-link"></i>
                                            Показать на сайте
                                        </i>
                                    </div>
                                </drag-and-drop>
                            </td>
                            <td valign="top">
                                <vee-textarea
                                    v-model="M.network.name"
                                    taClass="large"
                                    placeholder="Название"
                                    :readonly="currentUser.role !== 'admin'"
                                    :v-beautify="'capitalize itemclean typograf'" rules="required"
                                    taStyle="min-height: 80px"
                                    autofocus
                                ></vee-textarea>
                                <div style="display: inline-block;width: 50%;">
                                    <label>Форма собственности</label>
                                    <ValidationProvider vid="proprietary"  name="Форма собственности" rules="required" v-slot="{ errors }">
                                        <v-select
                                            :disabled="M.network.clinics.length > 0"
                                            :class="{ 'hasError': errors[0]}"
                                            v-tooltip.right="{
                                                                content: errors[0],
                                                                template: $errTemplate,
                                                            }"
                                            v-model="M.network.proprietary"
                                            :options="[
                                                            { value: 'private', text: 'Частная' },
                                                            { value: 'municipal', text: 'Государственная' },
                                                            { value: 'multi', text: 'Мульти' }
                                                        ]"
                                        ></v-select>
                                    </ValidationProvider>
                                </div>
                                <div v-if="M.network.proprietary !== 'multi'" style="display: inline-block;width: 49%;">
                                    <label>Город</label>
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <v-select
                                            v-model="M.network.city"
                                            :class="{ 'hasError': errors[0]}"
                                            v-tooltip.right="{content: errors[0],
                                                          template: $errTemplate,}"
                                            :disabled="M.network.id !== '' && !$can('admin.networks.changeCity')"
                                            :options=' cityOptions.map(({ text, value }) => {return { text,value }})'
                                        ></v-select>
                                    </ValidationProvider>
                                </div>

                                <div v-if="M.network.id === ''">
                                    <label v-if="M.network.proprietary === 'private'">Страница ДОКТУ</label>
                                    <table class="grid">
                                        <tr>
                                            <td width="50" valign="top">
                                                <a v-if="M.network.proprietary === 'private'"
                                                   :href="$parent.$parent.frontendUrl+'/'+(M.network.city === '' ? '—' : M.network.city)+'/net/'+M.network.url"
                                                   target="_blank"
                                                   style="font-size: 16px">
                                                    {{$parent.$parent.frontendUrl}}/{{M.network.city === '' ? '-' : M.network.city}}/net/
                                                </a>
                                            </td>
                                            <td valign="top">
                                                <vee-input
                                                    v-model="M.network.url"
                                                    @input="checkUrl"
                                                    :rules="{required: true, urlAvailable: !urlAvailable}"
                                                    :invalid="!urlAvailable"
                                                    :class="{incorrectUrl: !urlAvailable, 'hidden-url': true}"/>
                                            </td>
                                            <td width="50" valign="top">
                                                <button class="small" @click.prevent="transliterate">trans</button>
                                            </td>
                                            <td width="60" valign="top">
                                                <div class="label bg-red" v-if="M.network.url == ''" style="top: -3px; position: relative;">Пустой</div>
                                                <div class="label bg-red" v-if="M.network.url != '' && !urlAvailable" style="top: -3px; position: relative;">Занят</div>
                                                <div class="label bg-green" v-if="M.network.url != '' && urlAvailable" style="top: -3px; position: relative;">ОК</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div v-else-if="M.network.proprietary === 'private'">
                                    <label>Страница ДОКТУ</label>
                                    <div class="input text-ellipsis">
                                        <a :href="$parent.$parent.frontendUrl+'/'+(M.network.city === '' ? '—' : M.network.city)+'/net/'+M.network.url"
                                           target="_blank"
                                           class="text-ellipsis">
                                            {{$parent.$parent.frontendUrl}}/{{M.network.city === '' ? '-' : M.network.city}}/net/{{M.network.url}}
                                        </a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>


                    <table class="grid" v-if="M.network.proprietary === 'private'">
                        <tr>
                            <td align="top">
                                <label>Сайт клиники (не публикуется)</label>
                                <vee-input
                                    v-model="M.network.website"
                                    vid="website"
                                    :rules="{clinicAnyOfSix: clinicAnyOfSix}"
                                    :v-beautify="striptagsTrim"
                                />
                                <label>Страница Вконтакте</label>
                                <vee-input v-model="M.network.socialVk"
                                           vid="socialVk"
                                           :rules="{clinicAnyOfSix: clinicAnyOfSix, socialVk: true}"
                                           :v-beautify="striptagsTrimNoHttp+' vk'"
                                />
                                <label>Telegram (id)</label>
                                <vee-input v-model="M.network.socialTg"
                                           vid="socialTg"
                                           :rules="{clinicAnyOfSix: clinicAnyOfSix}"
                                           :v-beautify="striptagsTrimNoHttp"
                                />
                            </td>
                            <td align="top">
                                <label>Канал YouTube</label>
                                <vee-input
                                    v-model="M.network.socialYoutube"
                                    vid="socialYoutube"
                                    :rules="{clinicAnyOfSix: clinicAnyOfSix, socialYoutube: true}"
                                    :v-beautify="striptagsTrimNoHttp+' youtube'"
                                />
                                <label>Страница Одноклассники</label>
                                <vee-input v-model="M.network.socialOk"
                                           vid="socialOk"
                                           :rules="{clinicAnyOfSix: clinicAnyOfSix, socialOk: true}"
                                           :v-beautify="striptagsTrimNoHttp+' ok'"
                                />
                                <label>WhatsApp (номер телефона)</label>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{clinicAnyOfSix: clinicAnyOfSix, socialWhatsApp: true}"
                                >
                                    <input
                                        v-model-phone="M.network.socialWhatsApp"
                                        :class="{'hasError': errors[0] || whatsAppPhoneError}"
                                        id="socialWhatsApp"
                                        v-tooltip="{
                                                        content: whatsAppPhoneError,
                                                        template: $errTemplate,
                                                    }"
                                    >
                                </ValidationProvider>
                            </td>
                            <td width="220" align="top">
                                <label>Телефон регистратуры</label>
                                <input v-model-phone="M.network.registryPhone"
                                       :class="{'hasError' : registryPhoneError}"
                                       v-tooltip="{
                                           content: registryPhoneError,
                                           template: $errTemplate,
                                       }"
                                       pattern="(\+?\d[- .\(\)]*){7,13}"/>
                                <label>Телефон Doctu.ru</label>
                                <input v-model-phone="M.network.phone"
                                       :class="{'hasError' : doctuPhoneError}"
                                       v-tooltip="{
                                           content: doctuPhoneError,
                                           template: $errTemplate,
                                       }"
                                       pattern="(\+?\d[- .\(\)]*){7,13}"/>
                                <!--                        <input v-model="M.network.phoneExt" width="50" placeholder="#доб" />-->
                                <label style="visibility: hidden">_</label>
                                <input style="visibility: hidden" />
                            </td>
                        </tr>
                    </table>

                    <div v-if="M.network.proprietary === 'private'">
                        <label>Описание</label>
                        <v-quill ref="quill" v-model="M.network.description" />
                    </div>
                </fieldset>
                <fieldset style="overflow: initial !important;">
                    <legend>Клиники сети</legend>
                    <table class="grid">
                        <tr>
                            <td>
                                <div class="textarea" v-for="(row, index) in M.network.clinics" style="position: relative">
                                    <span>{{row.name}}</span><br />
                                    <small>{{row.cityName}}, {{row.address}}, {{row.metroNames}}</small>
                                    <button class="tiny redHover" @click.prevent="removeClinic(index)" style="position: absolute; right: 2px; top: 2px;">✖</button>
                                </div>
                                <div v-if="M.network.clinics.length === 0" required :invalid="M.network.clinics.length === 0">
                                    <i>Нет клиник в сети</i>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <ValidationProvider vid="clinics"  name="Клиники сети" :rules="{required: M.network.clinics.length === 0}" v-slot="{ errors }">
                                    <v-select
                                    :class="{ 'hasError': errors[0]}"
                                    v-tooltip.right="{
                                        content: errors[0],
                                        template: $errTemplate,
                                    }"
                                    :disabled="M.network.city === '' && M.network.proprietary !== 'multi'"
                                    v-on:remove="addClinic"
                                    :options="foundClinics"
                                    @search-change="findClinics"
                                    placeholder="Поиск клиник...">
                                        <template v-slot="{ option }">
                                            <div class="textarea" >
                                                <span>{{ option.text }}</span>
                                                &nbsp;&nbsp;&nbsp;
                                                <span v-if="option.networkName !== null" class="label bg-red">
                                                    {{ option.networkName }}
                                                </span><br>
                                                <small v-if="M.network.proprietary === 'multi'">{{option.cityName}}, {{ option.address }}</small>
                                                <small v-else>{{ option.address }}</small>
                                            </div>
                                        </template>
                                    </v-select>
                                </ValidationProvider>
                            </td>
                        </tr>
                    </table>
                </fieldset>

                <fieldset :disabled="!canEdit" style="overflow: initial !important;" v-if="canReadTariff">
                    <legend>Подписки</legend>

                    <table class="table" style="table-layout: fixed;">
                        <thead>
                        <tr>
                            <th>Тариф</th>
                            <th>Длительность</th>
                            <th>Действует с/по</th>
                            <th width="100">Цена</th>
                            <th width="60">&nbsp</th>
                        </tr>
                        </thead>
                        <tbody>
                            <template v-for="(row, index) in M.subscriptions">
                                <tr v-if="deletedSubscriptions.indexOf(row.id) === -1" :key="index">
                                    <td>
                                        <span v-if="row.tariff === 'ONLY_LK'">Личный кабинет сети</span>
                                        <span v-if="!row.id" class="label label-danger" style="top:-2px; position: relative;">новая</span>
                                    </td>
                                    <td>
                                        <template v-if="row.duration">{{ row.duration }}дн</template>
                                        <template v-else>∞</template>
                                    </td>
                                    <td>
                                    <span :invalid="!!M.subscriptions[index-1] && (M.subscriptions[index-1].dateTill >= row.dateFrom || isEmptyDateTill(index)) ">
                                        {{ row.dateFrom | formatDatePeriod(row.dateTill) }}
                                    </span>
                                    </td>
                                    <td align="right">
                                        <template v-if="row.price !== null">{{ row.price }}руб</template>
                                        <template v-else>&mdash;</template>
                                    </td>
                                    <td align="center" style="padding: 0">
                                        <button class="tiny blueHover" @click.prevent.stop="editSubscription(index)" v-if="canEditTariff">Ред</button>
                                        <button v-if="row.id === '' || canDeleteSubscription(row.dateTill)"
                                                class="tiny redHover"
                                                @click.prevent.stop="subscriptionCancel(index, row)">✖
                                        </button>
                                    </td>
                                </tr>
                            </template>

                        <tr v-if="canEditTariff">
                            <td colspan="5" style="padding: 0">
                                <button class="small"
                                        style="margin: 4px 0 0 2px !important;"
                                        @click.prevent.stop="createSubscription">Добавить подписку на тариф
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <label>Комментарий (не публикуется)</label>
                    <textarea v-model="M.account.description" v-autoexpand></textarea>
                </fieldset>

                <fieldset v-if="M.network.proprietary === 'private'"
                          :disabled="!canEdit"
                          :class="{collapsed: !M.network.reportOn}">
                    <legend>
                        <label>
                            <input type="checkbox" v-model="M.network.reportOn" :value="true">
                            <span>Автоматизированная email отчетность</span>
                        </label>
                    </legend>
                    <table class="grid" v-if="M.network.reportOn">
                        <tr>
                            <td width="25%">
                                <label>Кому имя</label>
                                <vee-input type="text" v-model="M.network.reportToName" :disabled="!M.network.reportOn" :rules="{required: M.network.reportOn}" />
                            </td>
                            <td width="25%">
                                <label>Кому email</label>
                                <vee-input type="text" v-model="M.network.reportTo" :disabled="!M.network.reportOn" name="«Кому email»"
                                    :rules="{required: M.network.reportOn, email: true}"/>
                            </td>
                            <td width="25%">
                                <label>Копия email</label>
                                <vee-input name="«Копия email»" type="text" v-model="M.network.reportCc" :disabled="!M.network.reportOn" rules="email"/>
                            </td>
                            <td width="25%"></td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <vee-textarea rows="4" v-model="M.network.reportMessage"
                                    :disabled="!M.network.reportOn"
                                    :rules="{required: M.network.reportOn}"/>
                                <button class="tiny redHover" @click.prevent.stop="resetReportText"
                                    :disabled="!M.network.reportOn">
                                    Стандартный текст
                                </button>
                            </td>
                        </tr>
                    </table>
                </fieldset>
                <fieldset v-if="M.users.length > 0">
                    <legend>Пользователи</legend>
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Логин</th>
                            <th>ФИО</th>
                            <th>Email</th>
                            <th>&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="user in M.users" class="hover">
                            <td><b>{{user.login}}</b></td>
                            <td>{{user.fio}}</td>
                            <td>{{user.email}}</td>
                            <td v-if="user.deleted_at === null"  class="user-section__cell">
                                <div class="user-section__buttons">
                                    <button class="tiny blue" v-if="canActAsNetwork" @click.prevent.stop="tryLoginAsUser(user.login)">Войти</button>
                                    <button v-if="user.email && canEdit" class="tiny user-section__admin-button" @click.prevent="$root.resetPassword(user.email)">Сброс пароля</button>
                                </div>
                            </td>
                            <td v-else>Удален</td>
                        </tr>

                        </tbody>
                    </table>
                    <div></div>
                </fieldset>
                <create-user-fieldset @fetchUser="fetchUser"/>
            </form>
        </ValidationObserver>
        <footer>
            <v-loading-component @click="onUpdate" v-if="canEdit">
                <template slot-scope="{ loadingClass }">
                    <button :class="['green', loadingClass]">Сохранить</button>
                </template>
            </v-loading-component>
            <v-loading-component @click="loginAsSupport" v-show="M.account.id" v-if="canSupport">
                <template slot-scope="{ loadingClass }">
                    <button :class="['blue', loadingClass]">Техподдержка</button>
                </template>
            </v-loading-component>
                <v-loading-component v-if="canDelete && (M.network.id !== '')" @click="deleteNetwork" v-show="M.account.id">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['redHover', loadingClass]">Удалить</button>
                    </template>
                </v-loading-component>
        </footer>
    </v-dialog-old>
</template>

<script>
import Vue from "vue";
import {mapState} from "vuex";
import {STORAGE_PUBLIC} from "@global/const";
import { initialState } from "./EditDialogFields"
import CreateUserFieldset from "@common/CreateUser";
import ImageCropper from '@base/ImageCropper.vue';
import DragAndDrop from '@base/DragAndDrop.vue';
import DialogNetworkSubscription from "@dialogs/admin/networks/NetworkSubscriptionDialog";

export default {
    components: {
        CreateUserFieldset,
        ImageCropper,
        DragAndDrop,
        DialogNetworkSubscription
    },
    data () {
        return initialState();
    },
    mounted () {
        this.$store.dispatch('dictionary/fetchAllOptions');
    },
    watch: {
        'M.network.registryPhone' (val) {
            this.registryPhoneError = null;

            const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
            if (!val.trim() || val.match(phoneRegex)) {
                return;
            }

            this.registryPhoneError = 'Некорректный номер телефона';
        },
        'M.network.phone' (val) {
            this.doctuPhoneError = null;

            const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
            if (!val.trim() || val.match(phoneRegex)) {
                return;
            }

            this.doctuPhoneError = 'Некорректный номер телефона';
        },
        'M.network.socialWhatsApp' (val) {
            this.whatsAppPhoneError = null;

            const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
            if (!val.trim() || val.match(phoneRegex)) {
                return;
            }

            this.whatsAppPhoneError = 'Некорректный номер телефона';
        },
    },
    computed: {
        ...mapState({
            currentUser: state => state.currentUser,
            cityOptions: state => state.dictionary.cityOptions,
            localityOptions: state => state.dictionary.localityOptions,
            districtOptions: state => state.dictionary.districtOptions,
            metroOptions: state => state.dictionary.metroOptions,
            areaOptions: state => state.dictionary.areaOptions,
            typeOptions: state => state.dictionary.typeOptions
        }),
        clinicAnyOfSix () {
            return  ['@website', '@socialVk', '@socialOk', '@socialYoutube', '@socialTg', this.M.network.socialWhatsApp, 'private'];
        },
        canActAsNetwork () {
            return this.$canAny(['admin.networks.actAs'])
        },
        canEdit () {
            return this.$canAny(['admin.networks.update'])
        },
        canCreate () {
            return this.$canAny(['admin.networks.create'])
        },
        canDelete () {
            return this.$canAny(['admin.networks.delete'])
        },
        canSupport () {
            return this.$canAny(['admin.networks.support', 'admin.networks.support_lite'])
        },
        canReadTariff () {
            return this.$canAny(['admin.networks.tariff.read'])
        },
        canEditTariff() {
            return this.$canAny(['admin.networks.tariff.update'])
        },
        striptagsTrimNoHttp () {
            return "striptags trim nohttp";
        },
        striptagsTrim () {
            return "striptags trim";
        },
        storagePublicUrl () {
            return STORAGE_PUBLIC;
        },
    },
    methods: {
        fetchUser(user) {
            if (user === null){
                Vue.delete(this.M,'user')
            }else{
                Vue.set(this.M,'user',user)
            }
        },
        openNetworkPage() {
            window.open('http://doctu.ru/' + (this.M.network.city === '' ? '—' : this.M.network.city) + '/net/' + this.M.network.url, '_blank');
        },
        /*** cropper functions ***/
        openCropWithNewFile (file) {
            this.$refs.cropper.preloadFile(file);
            this.$refs.cropper.showModal();
        },
        imageCropperDelete: function (event) {
            this.$modal("Удалить логотип?", {
                    name: 'Удалить',
                    callback: () => {
                        this.M.network.img = '';
                    }
                },
                {
                    name: 'Нет'
                }
            );
        },
        imageCropperOpen () {
            if(this.M.network.img === ''){
                this.$refs.cropper.showFileChooser();
            }else{
                this.$refs.cropper.showModal();
            }
        },
        cropUploadSuccess (imageUrl, field) {
            this.M.network.img = imageUrl;
        },
        /************************/

        read: function (id, e = null) {
            this.resetComponentData();

            let requestPromise = this.axios.post('networks/read/' + id, {});

            requestPromise.then(response => {
                this.urlAvailable = true;
                Vue.set(this, 'M', response.data);
                this.actionType = 'update';
                this.$refs.dialog.show().then(() => {
                    this.initPhone();
                });
            })
            return requestPromise;
        },
        create () {
            this.resetComponentData();
            this.urlAvailable = true;
            this.actionType = 'create';
            this.$refs.dialog.show().then(() => {
                this.initPhone();
            });
        },
        initPhone () {
            Vue.nextTick().then(() => {
                this.M.network.registryPhone = this.M.network.registryPhone + ' ';
                this.M.network.phone = this.M.network.phone + ' ';
            })
        },
        transliterate () {
            this.M.network.url = this.$helper.transliterate(this.M.network.name).trimChars('-');
            this.checkUrl();
        },
        checkUrl () {
            if (this.$helper.transliterate(this.M.network.url).trimChars('-') !== this.M.network.url) {
                this.M.network.url = this.$helper.transliterate(this.M.network.url).trimChars('-');
                return;
            }
            if (this.M.network.url === ''){
                return;
            }
            let data = {
                id: this.M.network.id,
                url: this.M.network.url,
                model: 'Network'
            };
            this.axios.post('/checkUrl', data).then(response => {
                this.urlAvailable = response.data.urlAvailable;
            });
        },
        tryLoginAsUser: function (login) {
            if (this.M.network.clinics.length === 0){
                this.$modal("Доступ в личный кабинет сети ограничен.<br/> В сети нет ни одной клиники.",
                    {
                        btnClass: 'green',
                        name: 'OK',
                        callback: () => {}
                    },
                    true, '', false
                )
                return;
            }

            if (!this.M.hasActiveSubscription && !this.M.account.downgrade_notification_date && (this.M.network.proprietary === 'private' || this.M.network.proprietary === 'multi')) {
                this.$modal("Вход в ЛК под пользователем сети запустит отсчёт бесплатного периода до закрытия ЛК. <br/>Вы уверены, что хотите войти?",
                    {
                        btnClass: 'green',
                        name: 'Нет, не входить',
                        callback: () => {}
                    },
                    {
                        btnClass: 'red',
                        name: 'Да, войти и запустить отсчёт',
                        callback: () => {
                            this.loginAsUser(login)
                        }
                    },
                    true, '', false
                );
            } else {
                this.loginAsUser(login)
            }
        },
        loginAsUser: function (login) {
            window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);

            this.axios.post('loginAsUser', {login}).then((response) => {
                if (response.data.status === 'OK') {
                    this.openMatchedNetworkRoute()
                }
            });
        },
        loginAsSupport (loginAsButton) {
            loginAsButton.startLoadingAnimation();
            // window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);

            let data = {
                accountId: this.M.account.id,
                pathname: window.location.pathname
            };

            this.axios.post('/admin/loginAsSupport', data).then((response) => {
                if (response.data.status === 'OK') {
                    this.openMatchedNetworkRoute()
                }
                loginAsButton.stopLoadingAnimation();
            }).catch(() => {loginAsButton.stopLoadingAnimation();});
        },
        openMatchedNetworkRoute() {
            this.axios.get('/network/firstRoute').then(response => {
                window.open(response.data.redirect, '_blank');
            });
        },
        resetReportText () {
            this.M.network.reportMessage =
                '((ИмяПолучателя)), добрый день!\n' +
                'Высылаю Вам отчет по заявкам за ((Месяц)). В последнем столбце отметьте пожалуйста пациентов, которые пришли на прием.\n' +
                '--\n' +
                'С уважением к Вам и Вашему бизнесу,\n' +
                'Юрий Угаров\n' +
                'Исполнительный директор Doctu.ru\n' +
                '\n' +
                'E-mail: yu@doctu.ru\n' +
                'Моб.: +7(911)124-22-18';
        },
        onUpdate(btn) {
            btn.startLoadingAnimation();

            this.$refs.networkEditForm.validate().then(success => {
                if (!success || this.registryPhoneError || this.doctuPhoneError || this.whatsAppPhoneError) {
                    const el = document.querySelector(".hasError:first-of-type");
                    if (el) {
                        el.scrollIntoView({behavior: "smooth"});
                    }
                    btn.stopLoadingAnimation()
                    return;
                }

                if (this.$refs.quill && this.$refs.quill.inProcess) {
                    this.$refs.quill.quillEditor.setSelection(null)
                    setTimeout(() => {
                        this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                    }, 450)
                }else{
                    this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                }

            });
        },
        update() {
            let requestPromise = this.axios.post('networks/' + this.actionType + '/' + this.M.network.id, this.M);

            requestPromise.then(() => {
                this.$refs.dialog.hide();
                this.$parent.$refs.table.update();
            }) .catch((error) => { });

            return requestPromise;
        },
        addClinic: function (payload) {
            this.M.network.clinics.push({
                id: payload.id,
                name: payload.text,
                cityName: payload.cityName,
                address: payload.address
            });
            this.$nextTick(function () {
                this.$refs.networkEditForm.validate();
            });

            if (payload.children.length > 0) {
                this.$modal('Добавить дочерние клиники?',
                    {
                        name: 'ОК',
                        callback: () => {
                            for (const [, child] of Object.entries(payload.children)) {
                                if (this.M.network.clinics.find(option => option.id === child.id) || child.deleted_at !== null) {
                                    continue;
                                }

                                this.M.network.clinics.push({
                                    id: child.id,
                                    name: child.text,
                                    cityName: child.cityName,
                                    address: child.address
                                });
                            }
                        }
                    },
                    {
                        name: 'Отмена',
                    }
                )
            }
        },
        findClinics: function (query) {
            if (this.clinicSearchRequest) {
                this.clinicSearchRequest.cancel();
            }

            if (query.length > 2) {
                this.findClinicByName(query).then(res => {
                    this.foundClinics = res.data.suggestions.map(item => {
                        return {
                            id: item.data.id,
                            text: item.data.name.replace(/\xA0/g,' '),
                            cityName: item.data.cityName,
                            networkName: item.data.networkName,
                            address: item.data.address,
                            children: item.data.children,
                        }
                    })
                })
            } else {
                this.foundClinics = [];
            }
        },
        findClinicByName: function (name) {
            this.clinicSearchRequest = this.axios.CancelToken.source();

            return this.axios.post('/clinicsAutocomplete', {
                q: name,
                filter: {
                    exclude_ids: this.M.network.clinics
                        ? this.M.network.clinics.map(el => el.id)
                        : [],
                    city:  this.M.network.city,
                    proprietary: this.M.network.proprietary
                }
            }, {
                cancelToken: this.clinicSearchRequest.token
            });
        },

        deleteNetwork(deleteButton) {
            deleteButton.startLoadingAnimation();

            this.$modal('Вы уверены, что хотите удалить аккаунт Сети?\nОтмена действия невозможна.', {
                callback: () => {
                    this.axios.post('networks/delete/' + this.M.network.id).then(() => {
                        this.$refs.dialog.hide();
                        this.$parent.$refs.table.update();
                        deleteButton.stopLoadingAnimation();
                    });
                }
            }, {
                callback: () => {
                    deleteButton.stopLoadingAnimation();
                }
            });
        },
        removeClinic: function (index) {
            this.M.network.clinics.splice(index, 1);
        },
        resetComponentData () {
            Object.assign(this.$data, initialState());
        },
        isEmptyDateTill (index) {
            const dateTill = this.M.subscriptions[index - 1].dateTill;

            return dateTill !== undefined && dateTill !== null && dateTill.length === 0;
        },
        createSubscription: function () {
            this.$refs.networkSubscriptionDialog.createSubscription();
        },
        editSubscription: function (index) {
            this.$refs.networkSubscriptionDialog.edit(this.M.subscriptions[index], index);
        },
        subscriptionCancel: function (index, subscription) {
            if (!subscription.id) {
                this.M.subscriptions.splice(index, 1);
                return;
            }

            this.$modal('Вы действительно хотите удалить действующий тариф у клиники? Отменить действие будет невозможно.', {
                name: 'Да',
                callback: () => {
                    this.deletedSubscriptions.push(subscription.id);
                    this.M.subscriptions[index].isDeleted = true;
                },
                btnClass: 'red',
            }, {
                name: 'Нет',
                callback: () => {},
                btnClass: 'green',
            });
        },
        checkIfSubscriptionIntersects: function (subscription = {}, index = null) {
            for (const [key, another] of Object.entries(this.M.subscriptions)) {
                if (index === parseInt(key)) {
                    continue;
                }
                if (
                    (subscription.dateFrom >= another.dateFrom && subscription.dateFrom <= another.dateTill) ||
                    (another.dateFrom >= subscription.dateFrom && another.dateFrom <= subscription.dateTill) ||
                    (!another.dateTill && another.dateFrom <= subscription.dateTill) ||
                    (!subscription.dateTill && subscription.dateFrom <= another.dateTill) ||
                    (!subscription.dateTill && !another.dateTill)
                ) {
                    return false;
                }
            }

            return true;
        },
        handleCreatedSubscription: function (subscription) {
            if (!subscription.tariff) {
                return;
            }
            if (this.checkIfSubscriptionIntersects(subscription)) {
                this.M.subscriptions.push(subscription);
            } else {
                this.$refs.networkSubscriptionDialog.model.isInvalid = true;
            }
        },
        handleChangedSubscription: function (subscription, index) {
            if (!this.checkIfSubscriptionIntersects(subscription, index)) {
                this.$refs.networkSubscriptionDialog.model.isInvalid = true;
            } else if (subscription.tariff) {
                this.M.subscriptions.splice(index, 1, subscription);
            }
        },
        canDeleteSubscription: function (dateTill) {
            return this.$canAny(['admin.networks.tariff.delete']) &&
                (!dateTill || this.$moment(dateTill).startOf('day') >= this.$moment().startOf('day'));
        },
    },
}
</script>

<style lang="scss">
    #network {
        max-width: 1000px !important;
    }
    .hidden-url {
        overflow: hidden !important;
        text-overflow: ellipsis !important;
    }
    .deleted {
        text-decoration: line-through black;
    }
    .user-section {
        &__buttons {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: .3rem;
        }
        &__cell {
            width: 150px;
        }
    }
</style>
